export default __webpack_public_path__ + "static/NotoSans-Regular.subset-6aa9bed63d91f0c4057913110a4c3f31.woff";